@if (errorMessage) {
  <mat-error class="chat-mensagem-error">
    {{errorMessage}}
  </mat-error>
}

@if (loading()) {
  <div class="loading">
    <mat-spinner color="primary" diameter="24"></mat-spinner>
  </div>
}

@for (chatMensagem of chatMensagens() | sortByDate: 'criadoEm':'DESC':true; track chatMensagem.id; let i = $index) {
  <div class="message-row"
     [ngClass]="{
                    'me': chatMensagem.usuario.id === usuarioLogado.id,
                    'contact': chatMensagem.usuario.id !== usuarioLogado.id,
                    'first-of-group': isFirstMessageOfGroup(chatMensagem, i),
                    'last-of-group': isLastMessageOfGroup(chatMensagem, i)
                }">
    @if (shouldShowContactAvatar(chatMensagem, i)) {
      <chat-imagem
        [imagem]="chatMensagem.usuario.imgPerfil">
      </chat-imagem>
    }
    <div class="bubble">
      <div class="message">{{chatMensagem.mensagem}}{{chatMensagem?.componenteDigital?.fileName}}</div>
    </div>
    <div class="time text-secondary">
      @if (chatMensagem.id) {
        <span> {{chatMensagem.criadoEm | date:'short'}} </span>
      }
      @if (saving === true && !chatMensagem.id) {
        <span>Enviando...</span>
      }
      &nbsp;
    </div>
  </div>
}
